import React, { useState, setState, useEffect, useContext } from "react";
import { forwardRef, useRef, useImperativeHandle } from "react";
import { useHistory } from "react-router-dom";
import { Redirect } from "react-router-dom";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import axios from "axios";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";

import { UserContext } from "../../contexts/UserContext";
import Checkbox from "@material-ui/core/Checkbox";

import KeyboardEventHandler from "react-keyboard-event-handler";
import LoadingOverlay from "react-loading-overlay";
/*WagerLimit Components*/
import WagerLimitsList from "./wagerLimitsComponents/WagerLimitsList";
import WagerLimitsInfo from "./wagerLimitsComponents/WagerLimitsInfo";
import WagerLimitsTabs from "./wagerLimitsComponents/WagerLimitsTabs";
import "./WagerLimit.css";

const WagerLimit = forwardRef((props) => {
  const user = useContext(UserContext);
  const [wagerLimit, setWagerLimit] = React.useState();

  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
      useState,
      "& .MuiTextField-root": {
        width: 200,
      },
      "& .MuiFormGroup-row": {
        justifyContent: "center",
      },
      "& .MuiFormControl-root": {
        justifyContent: "center",
      },
    },
  }));
  const classes = useStyles();
  let history = useHistory();

  const requestProfile = () => {
    //Change for server api address
    const url =
      process.env.REACT_APP_API2_URL +
      "/Profile/PlayerProfileLimits_GetInfo?idProfileLimits=" +
      props.match.params.id;
    const timeout = setTimeout(() => {
      axios
        .get(url)
        .then((response) => response.data)
        .then((data) => {
          setWagerLimit(data);
        }, 500);

      return () => clearTimeout(timeout);
    });
  };

  useEffect(() => {
    requestProfile();
  }, []);

  useEffect(() => {
    requestProfile();
  }, [props.match.params.id]);

  const UpdateWagerLimit = ({
    idProfileLimits,
    profileName,
    notes,
    alternateProfile,
    alternateEnable,
  }) => {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    axios
      .post(
        process.env.REACT_APP_API2_URL + "/Profile/PlayerProfileLimits_Update",
        {
          IdProfileLimits: idProfileLimits,
          ProfileName: profileName,
          Notes: notes,
          AlternateProfile: alternateProfile,
          AlternateEnable: alternateEnable,
          IdUser: Number(userInfo.userId),
        }
      )
      .then((response) => response.data)
      .then(() => requestProfile());
  };

  const setCurrentWagerLimit = (WagerLimit) => {
    setWagerLimit(WagerLimit);
    let anothervar = WagerLimit.idProfileLimits.toString();
    history.push(anothervar);
  };
  return (
    <React.Fragment>
      {wagerLimit && (
        <>
          <div className="sticky top-0 flex-grow-0">
            <WagerLimitsList
              showLoading={props.showLoading}
              setWagerLimit={setCurrentWagerLimit}
            ></WagerLimitsList>
          </div>
          <div className="flex-1 pl-8 h-max">
            <Paper className={`${classes.root} flex flex-col gap-4`}>
              <div
                id="inputs"
                style={{
                  display:
                    "flex flex-col items-center justify-center text-center",
                }}
              >
                {true ? (
                  <WagerLimitsInfo
                    WagerLimit={wagerLimit}
                    UpdateWagerLimit={UpdateWagerLimit}
                  ></WagerLimitsInfo>
                ) : (
                  <WagerLimitsInfo
                    WagerLimit={wagerLimit}
                    UpdateWagerLimit={UpdateWagerLimit}
                  ></WagerLimitsInfo>
                )}
              </div>

              <WagerLimitsTabs
                AgentInfo={props.location}
                WagerLimit={wagerLimit}
                UpdateWagerLimit={UpdateWagerLimit}
                showLoading={props.showLoading}
              ></WagerLimitsTabs>
            </Paper>
          </div>
        </>
      )}
    </React.Fragment>
  );
});

export default WagerLimit;
